export const VerificationStatusEnum = new Map<number, { label: string }>([
  [1, { label: "Pending" }],
  [2, { label: "Verified" }],
  [3, { label: "Rejected" }],
]);
